module.exports = __webpack_public_path__ + "static/media/android.8060a012.svg";